import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=431208c2"
import script from "./vat.vue?vue&type=script&lang=js"
export * from "./vat.vue?vue&type=script&lang=js"
import style0 from "./vat.vue?vue&type=style&index=0&id=431208c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports